<template>
  <div v-if="me" class="panel-navigation-wrapper" :class="{ 'mobile-mode': isMobile }">
    <!-- <dialog-add-business v-if="me" ref="dialogAddBusiness" :is_business="me.company_type == 'agency' ? false : true"></dialog-add-business> -->

    <!-- Mobile Navigation Overlay -->
    <div v-if="isMobile && mobileNavOpen" class="mobile-nav-overlay" @click="closeMobileNav"></div>

    <v-app-bar v-if="showHeaderAndNav && !mini && !isMobile" app color="" class="header-top" elevation="0" v-on-clickaway="clickedOutsideUserMenu">
      <!-- <v-app-bar-nav-icon @click.stop="toggleMini = !toggleMini"></v-app-bar-nav-icon> -->
      <svg  @click.stop="toggleMini = !toggleMini" width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.874281 13.9223H15.0432C15.3495 13.9223 15.6324 14.1203 15.7856 14.4417C15.9387 14.7631 15.9387 15.1592 15.7856 15.4806C15.6324 15.802 15.3495 16 15.0432 16H0.874281C0.568018 16 0.285095 15.802 0.131912 15.4806C-0.0211563 15.1592 -0.0211563 14.7631 0.131912 14.4417C0.285107 14.1203 0.568014 13.9223 0.874281 13.9223ZM0.0170975 8.00011C0.0170975 8.2756 0.107409 8.53997 0.268131 8.73472C0.428854 8.92947 0.64699 9.03896 0.874266 9.03896H20.1428C20.4491 9.03896 20.732 8.84092 20.8852 8.51953C21.0383 8.19813 21.0383 7.80206 20.8852 7.48066C20.732 7.15926 20.4491 6.96123 20.1428 6.96123H0.874266C0.644024 6.95566 0.421576 7.06264 0.257029 7.25805C0.0926056 7.45345 0 7.72089 0 8.00009L0.0170975 8.00011ZM0.0170975 1.03909C0.0170975 1.31457 0.107409 1.57894 0.268131 1.77369C0.428854 1.96844 0.64699 2.07793 0.874266 2.07793H10.5855C10.8917 2.07793 11.1747 1.8799 11.3279 1.5585C11.4809 1.2371 11.4809 0.841032 11.3279 0.519638C11.1747 0.198239 10.8917 0.000205994 10.5855 0.000205994H0.874266C0.644024 -0.00535965 0.421576 0.101618 0.257029 0.297023C0.0926056 0.492428 -0.000125885 0.759863 0 1.03907L0.0170975 1.03909Z" fill="#19233A"/>
      </svg>     
      <div class="flex flex-row items-center justify-between flex-wrap mt-1" style="min-height: 60px;">
        <div class="header-right-part">

        </div>
      </div>
      
      <v-spacer></v-spacer>

      <!-- <div class="header-stats pt-1" v-if="me && me.company_type == 'agency' && !fetchingLocations && !fetchingStats">

        <div v-if="!hasRgChecking && hasRg" class="border-1 bg-green-600 text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right" @click="accessRg()" style="margin-top: -5px;"><i class="fa fa-sign-in-alt globe mr-2"> </i> ACCESS REVIEW GROWER</div>

        <div v-if="!hasRgChecking && !hasRg" class="border-1 bg-orange-600 text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right" @click="getRgAdvanced();" style="margin-top: -5px;"><i class="fa fa-globe mr-2"> </i> GET REVIEW GROWER</div>
      </div> -->

      <v-divider
          class="mx-4"
          vertical
        ></v-divider>
  
      <div style="position: relative;">
        <div class="flex" @click="toggleUserMenu()" style="cursor: pointer;">
          <a class="me-icon mr-2 rounded-full text-white shadow-inner focus:outline-none zoom" style="width: 40px; display: block; text-align: center;">
            <v-gravatar v-if="me" class="gravatar-pic" :email="me.email" default-img="https://regro-cdn.s3.amazonaws.com/images/profile_image.png" />
          </a>
          <div v-if="me && !mini" style="line-height: 20px;">
            <span class="me-icon-name">
              {{ me.first_name }} {{ me.last_name }}
            </span>
            <br />

            <span class="me-icon-email">
              {{ me.email }}
            </span>
          </div>
          <div v-if="!mini" class="ml-3" style="line-height: 40px;">
            <i class="mdi mdi-chevron-down me-icon-icon"></i>
          </div>
        </div>
        <div v-if="showUserMenu" class="rounded-lg bg-white shadow-md absolute min-w-full mt-3 right-0 user-menu p-6" style="z-index: 99;">
          <div class="flex" style="cursor: pointer;">
            <a class="me-icon mr-2 rounded-full text-white shadow-inner focus:outline-none zoom" style="width: 40px; display: block; text-align: center;">
              <v-gravatar v-if="me" class="gravatar-pic" :email="me.email" default-img="https://regro-cdn.s3.amazonaws.com/images/profile_image.png" />
            </a>
            <div v-if="me" style="line-height: 20px;">
              <span class="me-icon-name">
                {{ me.first_name }} {{ me.last_name }}
              </span>
              <br />

              <span class="me-icon-email">
                {{ me.email }}
              </span>
            </div>
          </div>

          <v-divider class="mt-3 mb-3"></v-divider>

            <ul class="me-icon-menu list-reset">
              <li><router-link to="/user-settings" class="py-1 block"><i class="mdi mdi-account-outline mr-1" style="font-size: 16px;"></i> Edit Profile</router-link></li>
              <!-- <li><router-link to="/billing" class="py-1 block"><i class="mdi mdi-credit-card-outline mr-1" style="font-size: 16px;"></i> Billing</router-link></li> -->

              <!-- <li v-if="$store.state.auth.owner && me.company_type != 'admin' && me.company_type != 'agency'"><a href="javascript: void(0);" @click="backToAgencyAdmin()" class="py-1 block font-medium whitespace-no-wrap" style="color: #f56565 !important;"><i class="fa fa-angle-double-left -mr-1"></i> Back to Agency Dashboard</a></li>
              <li v-if="$store.state.auth.admin && me.company_type != 'admin'"><a href="javascript: void(0);" @click="backToAdmin()" class="py-1 block font-medium whitespace-no-wrap" style="color: #f56565 !important;"><i class="fa fa-angle-double-left -mr-1"></i> Back to Administration</a></li> -->

              <v-divider  class="mt-3 mb-3"></v-divider>
              <li><a href="#" class="py-1 block logout-link ml-1" @click="logout" style="font-size: 12px !important; font-weight: bold;"><i class="fa fa-sign-out-alt -mr-3"></i> Sign Out</a></li>
            </ul>
        </div>
      </div>
      
    </v-app-bar>

    <v-navigation-drawer
      v-if="showHeaderAndNav"
      v-model="sidebarMenu"
      class="rg-sidebar-left"
      app
      floating
      :permanent="!isMobile"
      :temporary="isMobile"
      :mini-variant="mini && !isMobile"
      :width="250"
      :mini-variant-width="60"
      >
      <!-- Mobile Navigation Header -->
      <div v-if="isMobile" class="mobile-nav-header">
        <h1 class="mobile-nav-title">Geo Grid Rank Tracker</h1>
        <v-btn icon @click="closeMobileNav" class="mobile-nav-close">
          <i class="mdi mdi-close" style="color: white; font-size: 24px;"></i>
        </v-btn>
      </div>

      <v-list dense color="" dark :class="{ 'mobile-nav-list': isMobile }">
            <!-- Toggle button for mini mode (Desktop only) -->
            <v-list-item v-if="mini && !isMobile" @click="toggleMini = !toggleMini" class="mb-2" style="opacity: 1; cursor: pointer;">
              <v-list-item-icon style="text-align: center; margin: 0; justify-content: center;">
                <i class="mdi mdi-menu" style="color: white; font-size: 20px;"></i>
              </v-list-item-icon>
            </v-list-item>

            <!-- Desktop Title -->
            <v-list-item v-if="!isMobile" class="" style="opacity: 1;">
              <v-list-item-content v-if="!mini">
                  <v-list-item-title>
                      <router-link to="/scans" class="">
                         <h1 class="text-white text-center">Geo Grid Rank Tracker</h1>
                      </router-link>
                  </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon v-else style="text-align: center; margin: 0; justify-content: center;">
                  <router-link to="/scans" class="">
                     <h1 class="text-white text-xl" style="margin: 0; font-weight: bold;">GR</h1>
                  </router-link>
              </v-list-item-icon>
          </v-list-item>
      </v-list>

      <v-list class="-mt-4" :class="{ 'mobile-nav-content': isMobile }">
          <div v-if="me && me.company_type == 'admin'">
            <v-tooltip right :disabled="!mini" v-for="item in menu_items.admin" :key="item.title">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  link
                  :to="item.route"
                  :href="item.href"
                  :target="item.target"
                  v-bind="attrs"
                  v-on="on"
                  :class="{ 'mobile-nav-item': isMobile, 'active-nav-item': $route.path === item.route }"
                >
                  <v-list-item-icon :style="mini && !isMobile ? 'padding-left: 0px; text-align: center;' : 'padding-left: 26px; text-align: center;'">
                      <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;"></i>
                  </v-list-item-icon>
                  <v-list-item-content>
                      <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </div>

          <div v-else-if="me && me.company_type == 'agency'">
            <span v-for="item in menu_items.agency" :key="item.title">
              <v-tooltip right :disabled="!mini">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    :to="item.route"
                    :href="item.href"
                    :target="item.target"
                    v-bind="attrs"
                    v-on="on"
                    :class="{ 'mobile-nav-item': isMobile, 'active-nav-item': $route.path === item.route }"
                  >
                    <v-list-item-icon :style="mini && !isMobile ? 'padding-left: 0px; text-align: center;' : 'padding-left: 26px; text-align: center;'">
                        <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>{{ item.title }}</span>
              </v-tooltip>
            </span>
          </div>
          <div v-else>
            <span v-for="item in menu_items.common" :key="item.title">
              <v-tooltip right :disabled="!mini">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    :to="item.route"
                    :href="item.href"
                    :target="item.target"
                    v-bind="attrs"
                    v-on="on"
                    :class="{ 'mobile-nav-item': isMobile, 'active-nav-item': $route.path === item.route }"
                  >
                    <v-list-item-icon :style="mini && !isMobile ? 'padding-left: 0px; text-align: center;' : 'padding-left: 26px; text-align: center;'">
                        <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>{{ item.title }}</span>
              </v-tooltip>
            </span>
          </div>
      </v-list>

      <!-- Mobile Bottom Profile Section -->
      <template v-if="isMobile">
        <v-spacer></v-spacer>
        <div class="mobile-nav-bottom">
          <div class="mobile-nav-profile">
            <!-- Profile Initials -->
            <div class="mobile-profile-avatar" @click="$router.push('/user-settings')">
              <span>{{ me ? (me.first_name.charAt(0) + me.last_name.charAt(0)).toUpperCase() : 'US' }}</span>
            </div>
            <!-- Logout Button -->
            <div class="mobile-logout-section" @click="logout">
              <i class="mdi mdi-logout-variant" style="font-size: 20px; margin-right: 8px;"></i>
              <span>Log Out</span>
            </div>
          </div>
        </div>
      </template>
  </v-navigation-drawer>

  <!-- Mobile Header (Shows on all pages when in mobile mode) -->
  <div class="mobile-header" v-if="isMobile && showHeaderAndNav">
    <button class="hamburger-menu" @click="openMobileNav">
      <i class="mdi mdi-menu"></i>
    </button>
    <h1 class="mobile-title">Geo Grid Rank Tracker</h1>
    <div class="mobile-header-spacer"></div>
  </div>

  <div v-if="!showHeaderAndNav" style="height: 100%;">
    <div v-if="hasAccess" style="height: 100%;">
      <slot v-if="me "></slot>
      <!-- <div v-if="me && me.status == 0" class="">
        Your access has been disabled. Please contact your account owner.
      </div> -->
    </div>
    
    <div v-if="me && !hasAccess">
        You do not have access to this section. In order to get access, please <a href="/billing">upgrade</a> your account.
      </div>
  </div>

  <v-container v-else class="lfp-container" :class="{'expandable-container': expandable}" fluid :style="containerStyle">
      <v-row :class="{'fill-height': !expandable}">
          <v-col>
              <div :class="{'fill-height': !expandable}" v-if="hasAccess">
                <slot v-if="me "></slot>
                <!-- <div v-if="me && me.status == 0" class="">
                  Your access has been disabled. Please contact your account owner.
                </div> -->
              </div>

              <div v-if="me && !hasAccess">
                  You do not have access to this section. In order to get access, please <a href="/billing">upgrade</a> your account.
                </div>
          </v-col>
      </v-row>
  </v-container>

  </div>



</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway';
import dialogAddBusiness from '@/components/dialogs/businesses/addBusiness.vue'

export default {
  name: 'PanelNavigation',
  mixins: [ clickaway ],

  props: ['inbox', 'defaultMini', 'expandable', 'customPadding', 'mobileEnabled'],

  // Provide methods to child components
  provide() {
    return {
      toggleMobileNavigation: () => this.openMobileNav()
    }
  },

  data: function() {
    return {
      showUserMenu: false,
      loaded: false,
      locations_links_visible: false,
      locations_links_done: false,

      drawer: false,
      group: null,

      sidebarMenu: true,
      toggleMini: this.defaultMini || false,
      mobileNavOpen: false,
      windowWidth: window.innerWidth,
      menu_items: {
        admin: [
          { title:"Dashboard", route:"/dashboard", icon:"mdi mdi-view-dashboard-outline" },
          { title:"Users", route:"/admin-users", icon: "mdi mdi-account" },
          { title:"Reports", route:"/admin/reports", icon:"mdi mdi-forum-outline" },
        ],
        agency: [
          { title:"Dashboard", route:"/dashboard", icon:"mdi mdi-view-dashboard-outline" },
          { title:"Leads", route:"/local-recon/leads", icon:"mdi mdi-account-multiple-outline" },
          { title: "Widgets", route: "/local-recon/widgets", icon: "mdi mdi-widgets-outline", only_owner: false },
          { title:"Reports", route:"/local-recon/reports", icon:"mdi mdi-forum-outline" },
          { title: "Scheduled Reports", route: "/local-recon/scheduled-reports", icon: "mdi mdi-calendar" },
          { title:"Settings", route:"/settings", icon:"mdi mdi-cog-outline" },
          { title:"API Docs", href: process.env.VUE_APP_DOCS_ENDPOINT, icon:"mdi mdi-xml", target: 'lr-api-docs' },
        ],
        business: [
          { title: "Dashboard", route: "/dashboard", icon: "mdi mdi-view-dashboard-outline" },
          { title: "Reviews", route: "/reviews", icon: "fa-star" },
          { title: "Review Platforms", route: "/review-platforms", icon: "fa-window-restore" },
          { title: "Widgets", route: "/widgets", icon: "fa-th" },
          { title: "Contacts", route: "/contacts", icon: "fa-users" },
          { title: "Feedback", route: "/feedback", icon: "far fa-star" },
          { title: "Get Reviews", route: "/user-settings", icon: "fa-plus" },
          { title: "Social Posting", route: "/social-posting", icon: "fas fa-share-alt" },
          { title: "Reports", route: "/reports", icon: "fa-file" }
        ],
        common: [
          // { title:"Dashboard old", route:"/dashboard", icon:"mdi mdi-view-dashboard-outline" },
          { title:"Scans", route:"/scans", icon:"mdi mdi-history" },
          // { title:"Grids", route:"/grid-scans", icon:"mdi mdi-grid" },
          { title:"Settings", route:"/user-settings", icon:"mdi mdi-cog-outline" },
        ],
      },

      inbox_count: this.$store.state.inbox_count || 0,

      hasRgChecking: true,
      hasRg: false,

      rg_user_uuid: "",
      rg_user_origin: ""
    }
  },
  components: {
    dialogAddBusiness
  },
  methods: {
    toggleTheme() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
      // UserMenu state toggled
    },
    openMobileNav() {
      console.log('openMobileNav called in PanelNavigation');
      this.sidebarMenu = true;
      this.mobileNavOpen = true;
    },
    closeMobileNav() {
      this.sidebarMenu = false;
      this.mobileNavOpen = false;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      // Close mobile nav if resizing to desktop
      if (this.windowWidth > 768) {
        this.mobileNavOpen = false;
      }
    },
    async logout() {
      axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/add-activity`, {
        activity: "Logged out."
      }, {
        headers: {
          'Authorization': 'Bearer ' + (this.$store.getters['auth/jwt'] || this.$store.getters['auth/accessToken'])
        }
      })

      let email = this.me.email
      try {
        await this.$store.dispatch('auth/logout')
        this.$router.push('/')

        setTimeout(function() {
          analytics.track('Signed Out', {
            username: email
          });
        }, 2000);

      } catch (e) {
        console.log(e)
      }
    },
    clickedOutsideUserMenu() {
      this.showUserMenu = false
    },


  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      showHeaderAndNav: function() {
        
        if (this.$router.currentRoute.name == 'local_recon_widgets_create')
          return false;

        if (this.$router.currentRoute.name == 'local_recon_widgets_edit')
          return false;

        if (this.$router.currentRoute.name == 'local_recon_widgets_edit_token')
          return false;


        
        if (this.$router.currentRoute.name == 'widgets_create')
          return false;
        
        if (this.$router.currentRoute.name == 'widgets_edit')
          return false;
        
        if (this.$router.currentRoute.name == 'widgets_edit_token')
          return false;


        
        if (this.$router.currentRoute.name == 'review-funnel')
          return false;



        if (this.$router.currentRoute.name == 'contact_form')
          return false;

        if (this.$router.currentRoute.name == 'ImageEditor')
          return false;

        return true;
      }
    }),
    mini() {
        // Only use manual toggle, not automatic based on screen size
        return this.toggleMini
    },
    buttonText() {
        return !this.$vuetify.theme.dark ? 'Go Dark' : 'Go Light'
    },
    hasAccess() {
      return true;
    },
    isMobile() {
      return this.mobileEnabled && this.windowWidth <= 768;
    },
    containerStyle() {
      if (this.inbox === true) {
        return 'padding: 0px; margin: 0px;';
      } else if (this.customPadding) {
        return `padding: ${this.customPadding} !important;`;
      } else {
        return 'padding: 40px;';
      }
    }
  },
  mounted() {
    this.$store.dispatch('me/fetch')

    // Add resize listener for mobile responsiveness
    window.addEventListener('resize', this.handleResize);

    // Listen for mobile nav open event from any child component
    this.$root.$on('open-mobile-nav', () => {
      console.log('Received open-mobile-nav event in PanelNavigation');
      this.openMobileNav();
    });

    // console.log(this.$store.state)
  },
  created() {
    // On mobile, hide sidebar by default
    if (this.mobileEnabled && window.innerWidth <= 768) {
      this.sidebarMenu = false;
    } else if (window.outerWidth < 900 && !this.mobileEnabled) {
      this.sidebarMenu = false;
    }
  },
  beforeDestroy() {
    // Clean up event listeners
    window.removeEventListener('resize', this.handleResize);
    this.$root.$off('open-mobile-nav');
  },
  watch: {
    group () {
      this.drawer = false
    },
  },
}
</script>

<style lang="css" scoped>
  .v-navigation-drawer__content a {
    text-decoration: none;
  }
  
  .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 20px;
  }
  
  .mx-auto.v-card, .v-list-item {
    height: 56px;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }
  
  .fade-enter-active {
    transition-delay: .25s;
  }
  
  .fade-enter, .fade-leave-active {
    opacity: 0
  }
  
  .menu .router-link-exact-active {
    color: white !important;
  }
  
  .v-application ul, .v-application ol {
    padding-left: 0px;
  }
  
  .menu a {
    color: #c6f6d5;
  }
  
  .user-menu li i {
    width: 24px;
  }
  
  .locations-dropdown {
    width: 500px;
  }
  
  .header-right-items {
    float: left; margin-top: -31px; padding-right: 10px;
  }
  

  
  .mobile-navigation .v-btn__content i {
    font-size: 40px;
  }
  
  .mobile-navigation a {
    color: #757575;
    font-size: 15px;
    width: 100%;
    display: block;
    font-weight: bold;
  }
  
  .mobile-navigation a i {
    /* margin-right: 5px; */
    width: 24px;
  }
  
  @media screen and (max-width: 1023px) {
    .locations-dropdown {
      width: 275px;
    }
  }
  
  /* Mobile Header - For hamburger menu */
  .mobile-header {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    z-index: 50;
    align-items: center;
    padding: 0 15px;
    width: 100vw;
  }

  .hamburger-menu {
    background: none;
    border: none;
    font-size: 24px;
    color: #333;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-title {
    flex: 1;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    color: #333;
  }

  .mobile-header-spacer {
    width: 40px; /* Same width as hamburger button for centering */
  }

  /* Mobile Navigation Overlay */
  .mobile-nav-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200; /* Higher z-index for overlay */
    display: block;
  }

  /* Ensure navigation drawer has proper z-index on mobile */
  .rg-sidebar-left {
    z-index: 201 !important; /* Higher than overlay */
  }

  /* Mobile Navigation Header */
  .mobile-nav-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 10px;
  }

  .mobile-nav-title {
    color: white;
    font-size: 17px;
    font-weight: 600;
    margin: 0;
  }

  .mobile-nav-close {
    color: white !important;
  }

  /* Mobile Navigation List */
  .mobile-nav-list {
    padding-top: 0 !important;
  }

  /* Mobile Navigation Content - Ensure scrolling doesn't go behind profile */
  .mobile-nav-content {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 20px; /* Extra padding so last item is visible */
  }

  /* Mobile Navigation Items */
  .mobile-nav-item {
    margin: 8px 16px !important;
    border-radius: 8px !important;
    transition: background 0.2s;
  }

  .mobile-nav-item:hover {
    background: rgba(255, 255, 255, 0.05) !important;
  }

  .mobile-nav-item.active-nav-item {
    background: rgba(0, 229, 134, 0.15) !important;
    position: relative;
  }

  .mobile-nav-item.active-nav-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 24px;
    background: #00E586;
    border-radius: 0 4px 4px 0;
  }

  /* Mobile Navigation Bottom Profile Section */
  .mobile-nav-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 16px 20px;
    /* background: #1a237e; */
    /* border-top: 1px solid rgba(255, 255, 255, 0.1); */
    z-index: 202; /* Higher than drawer to ensure visibility */
    width: 250px; /* Match drawer width */
    /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3); */
  }

  .mobile-nav-profile {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .mobile-profile-avatar {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;
  }

  .mobile-profile-avatar:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  .mobile-profile-avatar span {
    color: white;
    font-weight: 600;
    font-size: 18px;
  }

  .mobile-logout-section {
    display: flex;
    align-items: center;
    color: white;
    cursor: pointer;
    padding: 10px 16px;
    border-radius: 8px;
    transition: background 0.2s;
  }

  .mobile-logout-section:hover {
    background: rgba(255, 255, 255, 0.05);
  }

  .mobile-logout-section span {
    font-size: 16px;
  }

  /* Mobile Navigation Drawer Styles */
  @media (max-width: 768px) {
    /* Show mobile header on mobile */
    .mobile-header {
      display: flex !important;
    }

    /* Adjust container padding for mobile to account for fixed header */
    .mobile-mode .lfp-container {
      padding: 80px 15px 20px 15px !important; /* top right bottom left */
    }

    /* Make navigation drawer full height with space for bottom profile */
    .rg-sidebar-left .v-navigation-drawer__content {
      display: flex;
      flex-direction: column;
      padding-bottom: 100px; /* Space for profile section */
      overflow-y: auto;
      max-height: calc(100vh - 100px); /* Ensure content doesn't go behind profile section */
    }

    /* Ensure the mobile drawer itself has proper positioning */
    .v-navigation-drawer--temporary.rg-sidebar-left {
      z-index: 201 !important;
    }
  }

  @media screen and (max-width: 767px) {
    .header-right-part {
      width: 100%;
    }
    .header-right-items {
      width: calc(100% - 37px);
    }
    .locations-dropdown {
      width: 100%;
    }
    .header-stats {
      display: none;
    }
    /* .me-icon {
      margin-top: 20px;
    } */
  
    .desktop-navigation {
      display: none;
    }
  
    .mobile-navigation {
      display: block;
    }
  
    .container {
      max-width: 100% !important;
    }
  }
  
  .user-menu {
    min-width: 300px !important;
  }
  
  .locations-links {
    padding-right: 20px;
    text-align: right;
    margin-top: 4px;
    z-index: 9;
    margin-bottom: 5px;
  }
  
  .locations-links {
    font-size: 14px;
  }
  
  .locations-links a {
    color: #1976d2;
  }
  
  .header-stats {
    color: #828282;
    margin-bottom: 6px;
    text-align: right;
  }
  
  .gravatar-pic {
    border-radius: 50%;
  }

  .lsnp-inbox-count {
    position: absolute;
    margin-left: 45px;
    margin-top: -3px;
    background: #3A9BDB;
    color: #FFFFFF;
    padding: 2px;
    border-radius: 50%;
    font-size: 12px;
    padding-left: 5px;
    padding-right: 5px;
  }

  @media screen and (max-width: 900px) {
    .v-list-item__icon {
      padding-left: 0px !important;
    }

    .lfp-container {
      padding: 25px !important;
    }
  }

  /* Make the wrapper handle the background and expand with content */
  .panel-navigation-wrapper {
    min-height: 100vh;
    background-color: #F0F1F1;
    display: flex;
    flex-direction: column;
  }

  /* Default container for fixed layouts (ViewGrid, RecurringGrid) */
  .lfp-container {
    background-color: #F0F1F1;
    min-height: calc(100vh - 64px);
    flex: 1;
  }

  /* Expandable container for scrollable content (Scans, UserSettings) */
  .lfp-container.expandable-container {
    background-color: #F0F1F1;
    min-height: calc(100vh - 64px);
    height: auto !important;
  }

  /* Ensure fill-height works for fixed layouts */
  .lfp-container:not(.expandable-container) {
    display: flex;
    flex-direction: column;
  }

  .lfp-container:not(.expandable-container) > .row.fill-height {
    flex: 1;
  }
  </style>
  